import { Image } from '@acme/assets';
import type { TicketResponse } from '@acme/domains';
import { TicketStatusBadge } from '@acme/domains';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeadCell,
  TableRow,
} from 'flowbite-react';

export interface TicketsTableProps {
  tickets: TicketResponse[];
  onRowClick?: (ticketId: string) => void;
}

const formatDate = (dateString?: string): string => {
  if (!dateString) return '—';
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
};

export const TicketsTable: React.FC<TicketsTableProps> = ({
  tickets,
  onRowClick,
}) => {
  return (
    <div className="bg-white border border-gray-200 rounded-lg p-6">
      {tickets.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-16 px-6">
          <div className="w-40 h-40 mb-6">
            <Image
              name="mailbox"
              width="100%"
              height="100%"
              alt="Mailbox"
              className="object-contain"
            />
          </div>
          <p className="text-base text-gray-500 text-center">
            Ничего не найдено
          </p>
        </div>
      ) : (
        <div className="overflow-x-auto">
          <Table>
            <TableHead className="bg-gray-50">
              <TableRow>
                <TableHeadCell className="py-4 px-4 text-xs font-semibold text-gray-500 uppercase">
                  ID
                </TableHeadCell>
                <TableHeadCell className="py-4 px-4 text-xs font-semibold text-gray-500 uppercase">
                  Номер заявки
                </TableHeadCell>
                <TableHeadCell className="py-4 px-4 text-xs font-semibold text-gray-500 uppercase">
                  Обновлено
                </TableHeadCell>
                <TableHeadCell className="py-4 px-4 text-xs font-semibold text-gray-500 uppercase">
                  Категория
                </TableHeadCell>
                <TableHeadCell className="py-4 px-4 text-xs font-semibold text-gray-500 uppercase">
                  Тема
                </TableHeadCell>
                <TableHeadCell className="py-4 px-4 text-xs font-semibold text-gray-500 uppercase">
                  Статус
                </TableHeadCell>
              </TableRow>
            </TableHead>
            <TableBody className="divide-y divide-gray-200">
              {tickets.map((ticket) => {
                return (
                  <TableRow
                    key={ticket.id}
                    className="bg-white hover:bg-gray-50 cursor-pointer"
                    onClick={() => ticket.id && onRowClick?.(ticket.id)}
                  >
                    <TableCell className="py-4 px-4 text-sm text-gray-900 whitespace-nowrap">
                      #{ticket.number || '—'}
                    </TableCell>
                    <TableCell className="py-4 px-4 text-sm text-gray-900 whitespace-nowrap">
                      {ticket.applicationCode || '—'}
                    </TableCell>
                    <TableCell className="py-4 px-4 text-sm text-gray-900 whitespace-nowrap">
                      {formatDate(ticket.updateAt)}
                    </TableCell>
                    <TableCell className="py-4 px-4 text-sm text-gray-900">
                      {ticket.categoryId?.name || '—'}
                    </TableCell>
                    <TableCell className="py-4 px-4 text-sm text-gray-900">
                      {ticket.subject || '—'}
                    </TableCell>
                    <TableCell className="py-4 px-4">
                      <TicketStatusBadge
                        statusId={ticket.status?.id}
                        size="sm"
                      />
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </div>
      )}
    </div>
  );
};
